/*
 * ShopDetails Messages
 *
 * This contains all the text for the ShopDetails component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteCartModal_title: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_title',
    defaultMessage: 'Al hacerlo, se eliminará tu pedido.',
  },
  deleteCartModal_message: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_message',
    defaultMessage: '¿Estás seguro que querés salir?',
  },
  deleteCartModal_cancel: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_cancel',
    defaultMessage: 'No',
  },
  deleteCartModal_accept: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_accept',
    defaultMessage: 'Sí, salir',
  },
  goToCart: {
    id: 'app.shopDetails.containers.ShopDetails.goToCart',
    defaultMessage: 'Ver mi pedido {cartTotal}',
  },
  shopDetails_age_validation_error: {
    id: 'app.productConfig.ShopDetails.ageValidation.error',
    defaultMessage:
      'Para ver los productos de esta sección es necesario que seas mayor de edad.',
  },
  shopDetails_age_validation_subtitle: {
    id: 'app.productConfig.shopDetails.ageValidation.subtitle',
    defaultMessage:
      'Para ver los productos de esta sección es necesario que seas mayor de edad.',
  },
  menuSection: {
    id: 'app.productConfig.shopDetails.menuSection',
    defaultMessage: 'Categorías',
  },
  deleteCartModal_new_title: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_new_title',
    defaultMessage: 'Vas a perder los productos que agregaste a tu pedido.',
  },
  deleteCartModal_new_message: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_new_message',
    defaultMessage: '¿Querés salir?',
  },
  deleteCartModal_new_cancel: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_new_cancel',
    defaultMessage: 'No, continuar pedido',
  },
  deleteCartModal_new_accept: {
    id: 'app.shopDetails.containers.ShopDetails.deleteCartModal_new_accept',
    defaultMessage: 'Sí, salir',
  },
  cartSectionAriaLabel: {
    id: 'app.shopDetails.containers.ShopDetails.RighColumnArialLabel',
    defaultMessage: 'Carrito',
  },
});
